var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSfxMu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 40,
    height: 40,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.719 8.288l6.585-5.121c0.223-0.175 0.508-0.28 0.818-0.28 0.368 0 0.701 0.149 0.942 0.39l3.993 3.992c0.241 0.241 0.39 0.575 0.39 0.943 0 0.31-0.106 0.595-0.283 0.822l0.002-0.003-5.12 6.584c0.183 0.715 0.288 1.537 0.288 2.383 0 5.524-4.475 10.002-9.998 10.007h-0c-4.669 0-10.669-2.003-14.003-4.003 5.307-4 4.063-6.413 4.667-8.667 1.411-5.267 6.456-8.343 11.719-7.045zM22.269 10.793c0.087 0.084 0.173 0.171 0.257 0.259l1.513 1.512 3.3-4.243-2.328-2.328-4.243 3.3 1.5 1.5z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfxMu);
export default __webpack_public_path__ + "static/media/sfx_mu.1d3ab2a2d5f09b9176dc6c91ed9a272a.svg";
export { ForwardRef as ReactComponent };